import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, ButtonResponsiveWrapper, LinkedEmployeeIcon, useResponsive } from '@common-fe/common-fe';

import { YES_KEY } from '@/common/constants';
import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
import {
  BannerActionCompleted,
  BannerStorageKey,
} from '@/modules/core/components/Dashboard/components/BannersList/bannersList.constants';
import useDismissBanner from '@/modules/core/components/Dashboard/components/BannersList/hooks/useDismissBanner';
import { useSwitchPopupStore } from '@/modules/user/components/UserDrodpdown/stores';

const LinkedEmployeeBanner = () => {
  const { isMobile } = useResponsive();
  const { setIsPopupVisible } = useSwitchPopupStore();
  const { t } = useTranslation();
  const { handleDismissBanner } = useDismissBanner();

  const handleDismiss = useCallback(() => {
    handleDismissBanner(BannerStorageKey.LinkedEmployeeBanner);
  }, [handleDismissBanner]);

  const handleOpenPopup = useCallback(() => {
    setIsPopupVisible(true);
    localStorage.setItem(BannerActionCompleted.ImportantChangesBannerAction, YES_KEY);
    window.scrollTo(0, 0);
  }, [setIsPopupVisible]);

  return (
    <Banner
      title={t('You Have Additional Accounts')}
      description={t(
        'Additional accounts have been linked to your login. You can easily switch between accounts to view your balance, transactions, account history, and more.'
      )}
      icon={<LinkedEmployeeIcon />}
      testId="LinkedEmployeeBanner"
    >
      <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
        <AppButton fill={isMobile} testId="show-me-how" onClick={handleOpenPopup} width="180px">
          {t('Show Me How')}
        </AppButton>

        <AppButton
          fill={isMobile}
          testId="LinkedEmployeeBanner_dismiss-banner"
          buttonType="secondary"
          width="180px"
          onClick={handleDismiss}
        >
          {t('Dismiss')}
        </AppButton>
      </ButtonResponsiveWrapper>
    </Banner>
  );
};

export default LinkedEmployeeBanner;
